/**
 * Core section: title, start date, status. Always visible.
 */

import { type ReactNode } from "react";
import {
  InlineTextField,
  InlineDateTimeField,
  InlinePickerRow,
  ExpandablePicker,
} from "../InlineFields.tsx";
import type { EventStatus } from "../../types.ts";

export interface CoreSectionProps {
  title: string;
  setTitle: (v: string) => void;
  startsAt: string;
  setStartsAt: (v: string) => void;
  endsAt: string;
  setEndsAt: (v: string) => void;
  status: EventStatus;
  setStatus: (v: EventStatus) => void;
  statusConfig: { label: string; bgColor: string; color: string };
  statusOptions: Array<{ value: EventStatus; label: string; badge?: ReactNode }>;
  showStatusPicker: boolean;
  setShowStatusPicker: (v: boolean) => void;
  publishAt?: string;
  setPublishAt?: (v: string) => void;
  statusNeedsPublishAt?: boolean;
  InlineDateTimeFieldPublish?: ReactNode;
}

export function CoreSection({
  title,
  setTitle,
  startsAt,
  setStartsAt,
  endsAt,
  setEndsAt,
  status,
  setStatus,
  statusConfig,
  statusOptions,
  showStatusPicker,
  setShowStatusPicker,
  InlineDateTimeFieldPublish,
}: CoreSectionProps) {
  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100 mb-4">
      <div className="card overflow-hidden">
        <InlineTextField
          label="Название"
          value={title}
          onChange={setTitle}
          placeholder="Название мероприятия"
          required
        />
        <InlineDateTimeField
          label="Начало"
          value={startsAt}
          onChange={setStartsAt}
          required
        />
        <InlineDateTimeField
          label="Окончание"
          value={endsAt}
          onChange={setEndsAt}
        />
        <InlinePickerRow
          label="Статус"
          value={statusConfig.label}
          onClick={() => setShowStatusPicker(!showStatusPicker)}
          isOpen={showStatusPicker}
          badge={
            <span
              className="w-2 h-2 rounded-full"
              style={{
                backgroundColor:
                  status === "PUBLISHED"
                    ? "#22c55e"
                    : status === "SCHEDULED"
                      ? "#3b82f6"
                      : status === "CANCELLED"
                        ? "#ef4444"
                        : "#94a3b8",
              }}
            />
          }
        />
        <ExpandablePicker
          isOpen={showStatusPicker}
          options={statusOptions}
          value={status}
          onChange={setStatus}
          onClose={() => setShowStatusPicker(false)}
        />
        {InlineDateTimeFieldPublish}
      </div>
    </div>
  );
}
